import { inject, InjectionKey } from "vue";
import apiService from "@/services/APIService";
// import apiService from "@/services/APIServiceDebug";

export default apiService;

export type APIService = ReturnType<typeof apiService>;

export const apiServiceKey: InjectionKey<APIService> = Symbol("APIService");

export const useAPI = () => {
  const api = inject(apiServiceKey);
  if (!api) {
    throw new Error(`${apiServiceKey} is not provided`);
  }
  return api;
};
